<template>
    <ModalBase :show-modal="showModal" @close-modal="close" :short="true" :auto-h="true" :narrow="true">
        <template v-slot:titlebar>
            <TitleBar variant-class="title-modal title-modal--simple">
                <template v-slot:title>
                    {{title}}
                </template>
            </TitleBar>
        </template>

        <template v-slot:maincontent>
            <div>
                {{body}}
            </div>
        </template>

        <template v-slot:actions>
            <b-form-group>
                <b-form-radio-group v-model="selectedChoice">
                    <div v-for="option in options" v-bind:key="option.key">
                        <b-form-radio :value="option.key" @input="onChoiceChange">{{option.text}}</b-form-radio>
                    </div>
                </b-form-radio-group>
                <div class="form-required text-danger" v-if="confirmationWarning">
                    <span>{{ $gettext('Please select an option') }}</span>
                </div>
            </b-form-group>

            <GekkoButton @click="close()" :text="$gettext('Cancel')" variant="outline-danger" />
            <GekkoButton @click="confirm()" :text="$gettext('Confirm')" class="float-right" />
        </template>
    </ModalBase>
</template>

<script>
import ModalBase from "@/components/base_components/ModalBase";
import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton";

export default {
    name: "ConfirmationDialog",
    components: {ModalBase, TitleBar, GekkoButton},
    props: {
        title: {
            type: String,
            default() {
                return "";
            }
        },
        body: {
            type: String,
            required: true
        },
        options: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            showModal: false,
            selectedChoice: null,
            confirmationWarning: false
        }
    },
    methods: {
        open() {
            this.selectedChoice = null;
            this.confirmationWarning = false;
            this.showModal = true;
        },
        close() {
            this.$emit("cancel");
            this.showModal = false;
        },
        refreshData() {
            this.selectedChoice = null;
        },
        validate() {
            if (!this.selectedChoice)
                this.confirmationWarning = true;
            else
                this.confirmationWarning = false;
        },
        confirm() {
            this.validate();
            if (!this.confirmationWarning) {
                this.$emit("confirmed", this.selectedChoice);
                this.refreshData();
                this.showModal = false;
            } else {
                this.$store.commit('setAlert', { title: this.$gettext('Missing fields'), text: this.$gettext('Please check form warnings.'), variant: 'danger', duration: 4 });
            }
        },
        onChoiceChange() {
            this.confirmationWarning = false;
        }
    }
}
</script>

<style scoped>
</style>